<div class="custom-modal">
  <div class="header">
    <h1 mat-dialog-title class="d-flex w-100 justify-content-between">
      Editar Perfil
    </h1>
    <mat-icon mat-dialog-close="cancel">close</mat-icon>
  </div>
  <mat-divider></mat-divider>
  <div class="col-12">
    <img [src]="'assets/images/user.jpg' | baseUrl">
  </div>
  <mat-divider></mat-divider>
  <div mat-dialog-content>
    <!-- <form [formGroup]="perfilForm" class=""> -->
    <mat-form-field class="col-6">
      <input matInput placeholder="Nome" autocomplete="off" type="text" tabIndex="1" [(ngModel)]="nome"
        readonly>
      <!-- <mat-error *ngIf="nome.invalid">Preencha um nome válido.</mat-error> -->
    </mat-form-field>
    <mat-form-field class="col-6">
      <input matInput placeholder="E-mail" autocomplete="off" type="email" tabIndex="1" [(ngModel)]="email"
        readonly>
      <!-- <mat-error *ngIf="email.invalid">Preencha um e-mail válido.</mat-error> -->
    </mat-form-field>
    <!-- <mat-form-field class="col-6" *ngIf="alterarsenha">
      <input matInput appAutoFocus placeholder="Nova senha" autocomplete="off" [type]="hide ? 'password' : 'text'" tabIndex="1"
        [(ngModel)]="senha">
        <button type="button" mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
        [attr.aria-pressed]="hide">
        <mat-icon>
          {{ hide ? "visibility_off" : "visibility" }}
        </mat-icon>
      </button>
    </mat-form-field>
    <mat-form-field class="col-6" *ngIf="alterarsenha">
      <input matInput placeholder="Repetir senha" autocomplete="off" [type]="hide ? 'password' : 'text'" tabIndex="1"
        [(ngModel)]="repetirSenha">
        <button type="button" mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
        [attr.aria-pressed]="hide">
        <mat-icon>
          {{ hide ? "visibility_off" : "visibility" }}
        </mat-icon>
      </button></mat-form-field> -->
    <!-- <app-password-meter *ngIf="alterarsenha" [password]="senha" (buttonPassword)="passwordValid($event)"></app-password-meter> -->
    <button mat-stroked-button class="float-left" (click)="modalConfirmacaoSenha(data.usuario)">Alterar senha</button>
    <button mat-flat-button class="float-right" color="primary" [disabled]="!passwordIsValid"
      (click)="submit()">Salvar</button>
    <!-- </form> -->
  </div>
</div>